const lessonData = {

  2: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {
        alt: "Mt Sinai security officer",
        image:
          "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/unnamed.png",
        order: 0,
      },
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "4", current_scene: "2", previous_scene: "1",text: "Continue" },
    ],
    scene_number: "2",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>The COVID-19 pandemic impacted everyone, especially those who work in healthcare organizations. A study published in 2021 found that 40% of healthcare workers were experiencing depression, anxiety, a stress disorder or moral injury. The Mount Sinai Health System opened the <a href="https://icahn.mssm.edu/research/center-stress-resilience-personal-growth" target="_blank" rel="noopener noreferrer">Center for Stress Resilience and Personal Growth</a> (CSRPG) in June 2020 as a, “resource available to all Mount Sinai faculty, staff, trainees, and medical and graduate students. Our Center has a long name but a simple mission – provide scientifically-grounded services that support the resilience and psychological well-being of our Mount Sinai community.” </p>

<p>The CSRPG is staffed by social workers, psychologists, psychiatrists and a healthcare chaplain and offers resilience workshops, individualized support, wellness hubs, and a range of other programs. Since its inception in 2020, CSRPG has conducted over 17,000 visits with 1,381 unique patients. In addition, CSRPG has conducted 840 Resilience workshops and huddles with over 2000 individuals. </p>`
    ],
    title: null,
    videos: [],
    audio: [],
  },
  
  4: {
    checkpoint: false,
    last: false,
    checkpoints: [], 
    images: [
    
    ],
    layoutNumber: 4,
    navigation: [
      { available_scene: "5", current_scene: "4", previous_scene: "2",text: "Continue" },
    ],
    scene_number: "4",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>Security officers are a frequently overlooked group of front-line workers in healthcare organizations where they are staffed 24 hours a day, 7 days a week. Their long work hours combined with physical hazards, sometimes challenging interactions with the public, and germs/pathogens can lead to exhaustion, distress and burnout.</p>

<p>During the pandemic, they were responsible for keeping healthcare organizations safe and secure while managing their own exposure to COVID-19. In the Mount Sinai Health System, security officers filled many roles during the pandemic, including new roles generated by the epidemic. CSRPG aims to serve all members of the Mount Sinai Health System, including security officers.
</p>`,
    ],
    title: "An Overlooked Group",
    videos: [],
    audio: [],
  },
  5: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [
      {
        alt: "Chaplain Zorina Costello",
        image:
          "https://chaplaincy-innovation-lab-lessons.s3.us-east-1.amazonaws.com/2025-01/Chaplain+Zorina+Costello.jpeg",
        order: 86,
      },
    ],
    layoutNumber: 1,
    navigation: [
      { available_scene: "6", current_scene: "5", previous_scene: "4",text: "Continue" },
    ],
    scene_number: "5",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You are Chaplain Zorina Costello. You work with CSRPG, and have gotten to know many of the security officers through her ten years at Mount Sinai Hospital. You work with them de-escalating patient and family situations and offering one on one support. You and Telvet Zimmerman, Director of Security Services at Mount Sinai Hospital began working together to explore how to extend and enhance the support offered through CSRPG to the security staff. </p>`,
    ],
    title: null,
    videos: [],
    audio: [],
  },
  6: {
    checkpoint: false,
    last: false,
    checkpoints: [],
    images: [],
    layoutNumber: 4,
    navigation: [
      { available_scene: "8", current_scene: "6", previous_scene: "5",text: "Continue" },
    ],
    scene_number: "6",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>There are about 174 security officers in the hospital who work days, nights and some
combination. Most work 37.5 hours per week. Shifts are typically 8 hour shifts with mandated overtime, a maximum of two overtime shifts per week.</p>

<p>The majority of security officers are men of color. Staff turnover is higher than ideal. Most communication occurs in team huddles, not through email. Some officers at times feel isolated. Prior to these efforts, the officers had not necessarily been able to speak about their experiences during COVID. Some are aware of the CSRPG but do not have time or flexibility during their working hours to attend workshops.
</p>`,
    ],
    title: "Security Staff Demographics",
    videos: [],
    audio: [],
  },       
  8: {
    checkpoint: false,
    last: false,
    checkpoints: [{
      alt: null,
      answer: false,
      content_type: 5,
      data:
        `<ul><li>How effectively did the chaplain collaborate in designing and implementing this work? </li>
        <li>To what extent might this approach be applicable to other front-line non-medical workers such as those on the dining or cleaning staff? Can you anticipate any different challenges for these groups?</li>
        <li>How might race, class, and gender have impacted how decisions were made in this situation? </li>
        <li>What is (or should be) the relationship between institutional support focused on individuals and change that requires system-wide re-thinking?</li>
        </ul>`,
      order: 0,
      question_type: 2,
      scene_number: "8",
      sidebar: false,
    }],
    images: [],
    layoutNumber: 9,
    navigation: [
      { available_scene: "10", current_scene: "8", previous_scene: "6",text: "Continue" },
    ],
    scene_number: "7",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [],
    title: null,
    videos: [],
    audio: [],
  },
  
  10: {
    checkpoint: false,
    last: true,
    checkpoints: [],
    images: [],
    layoutNumber: 6,
    navigation: [{available_scene: "10", current_scene: "10", previous_scene: "7",text: "End Lesson" }],
    scene_number: "10",
    sidebar: false,
    sidebarImages: [],
    sidebarVideos: [],
    sidebarText: [],
    text: [
      `<p>You’ve completed this case study lesson. In this situation, you considered how to reach an underserved population within the hospital setting. You were collaborative and flexible in your approach to ensure that the group felt invited into your offerings. You engaged with them when you faced resistance and continued to center their needs through program evaluation and planning for the future. </p>`
    ],
    title: "Lesson complete",
    videos: [],
    audio: [],
  },
};

export default lessonData;